// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"499":"686f01a9d53b7641","9631":"1217659d93a0cd4d"}[chunkId] + ".css";
};